module.exports = __webpack_public_path__ + "img/montreal ex.48a327ef.png";